"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInHighContrast = exports.default = void 0;
var isHighContrast = function isHighContrast() {
  // Check if it is first render in SSR
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(forced-colors: active)').matches;
};
var isInHighContrast = isHighContrast();
exports.isInHighContrast = isInHighContrast;
var _default = isHighContrast;
exports.default = _default;